// @flow
import { useUpdateResponseQueue } from 'queries/response_queue/useUpdateResponseQueue'
import * as React from 'react'
import { toast } from 'react-toastify'
import type { PacketResponse } from 'types/packet-response'
import type { Response } from 'types/response'

function useResponseQueue(
  response: ?Response,
  packetResponse: ?PacketResponse,
  setResponse: ?(Response) => void,
  setPacketResponse: ?(PacketResponse) => void
): {
  title: string,
  onClick: () => Promise<void>,
  loading: boolean,
} {
  const { updateResponseQueue, isLoading } = useUpdateResponseQueue()
  const isPacket = !!packetResponse
  const isQueued = isPacket ? packetResponse?.is_queued : response?.is_queued

  const onUpdateResponseQueue = React.useCallback(async () => {
    try {
      await updateResponseQueue({
        response_uid: isPacket ? packetResponse?.id ?? '' : response?.id ?? '',
        is_queued: !isQueued,
        is_packet: isPacket,
      })
      if (isPacket && packetResponse && setPacketResponse) {
        if (!packetResponse || !setPacketResponse) return undefined
        setPacketResponse({ ...packetResponse, is_queued: !isQueued })
      } else if (response && setResponse) {
        setResponse?.({ ...response, is_queued: !isQueued })
      }
      toast.success('Queue Updated')
    } catch (error) {
      toast.error('Failed to update response queue')
    }
  }, [
    isPacket,
    isQueued,
    packetResponse,
    response,
    setPacketResponse,
    setResponse,
    updateResponseQueue,
  ])

  return {
    title: isQueued ? 'Remove from Queue' : 'Send to Queue',
    onClick: onUpdateResponseQueue,
    loading: isLoading,
  }
}

export default useResponseQueue
